import React from "react"
import config from 'react-global-configuration';
import FacebookLogin from 'react-facebook-login';
import AuthActions from '../actions/AuthActions';
import AuthStore   from '../stores/AuthStore'
import Account from '../vo/Account'
import LineLogin from "./parts/LineLogin" ;
import HeaderAll from "./parts/HeaderAll"
//import Footer from "./parts/Footer"
//import styles from "../styles/index.css"


export default class IndexApp extends React.Component {

  constructor(){
    super()

    this.authStoreErrorChangeHandler = this.authStoreErrorChangeHandler.bind(this)
    this.authStoreUpdateHandler = this.authStoreUpdateHandler.bind(this)
    this.responseFacebook = this.responseFacebook.bind(this)
    this.responseLine = this.responseLine.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.authStoreChangeHandler = this.authStoreChangeHandler.bind(this)
    this.componentClicked = this.componentClicked.bind(this)
    this.is_facebook_login = false
    this.state = {
      account:null,
      account_type:"",
      account_id:"",
      error:null
    }
  }
  componentDidMount(){
    AuthStore.addChangeListener(this.authStoreChangeHandler)
    AuthStore.addChangeListener(this.authStoreErrorChangeHandler,"auth_error")
    AuthStore.addChangeListener(this.authStoreUpdateHandler,"account_update")
    AuthStore.addChangeListener(this.accountCreatedHandler,"account_created")
    AuthStore.addChangeListener(this.authStoreErrorChangeHandler,"auth_error")
    var url = new URL(window.location)
    var params = new URLSearchParams(url.search);
    if(params){
      this.setState({
        error:params.get("error")
      })
    }
  }

  componentClicked(){
    this.is_facebook_login = true
  }
  componentWillUnmount(){
    AuthStore.removeChangeListener(this.authStoreChangeHandler)
    AuthStore.removeChangeListener(this.authStoreErrorChangeHandler,"auth_error")
    AuthStore.removeChangeListener(this.authStoreUpdateHandler,"account_update")
    AuthStore.removeChangeListener(this.accountCreatedHandler,"account_created")
    AuthStore.removeChangeListener(this.authStoreErrorChangeHandler,"auth_error")
  }

  responseFacebook(response){
  //if(this.is_facebook_login){
    this.setState({
      account_type:"facebook",
      account_id:response.id
    })
    const item = new Account({
      name:response.name,
      mail:response.email
    })

    AuthActions.auth(response.id, "facebook",item,response.picture.data.url)
  //}
  }

  responseLine(user_id,user_name, picture){

    this.setState({
      account_type:"line",
      account_id:user_id
    })
    const item = new Account({
      name:user_name,
      mail:""
    })

    AuthActions.auth(user_id, "line",item,picture)
  }
  authStoreErrorChangeHandler(){
    if(AuthStore.isAuth()){
      window.location = "/club/member"
    }else{
      window.location = "/club/login?error=1"
    }
  }
  authStoreChangeHandler(){
    //console.log( AuthStore.getToken())
    //this.props.history.push("/payment")

    if(AuthStore.isAuth()){
      window.location = "/club/member/dashboard"
    }else{
      window.location = "/club/login?error=1"
    }

  //  console.log(AuthStore.isAuth())

  }



  authStoreUpdateHandler(){
    /*this.setState({
      account: AuthStore.getUserInfo()
    })*/
    this.props.history.push("/club/payment")
  }
  handleChange(e){
    const target = e.target
    AuthActions.update(target.name, target.value)
  }

  accountCreatedHandler(){

  }

  handleSubmit(){
      AuthActions.create(this.state.account_id, this.state.account_type, this.state.account)
  }

  signup(){
    window.location = "/club/signup"
  }


  render(){

    var inputHtml = null
    var message = null
    if(this.state.error === 1){
      message = "ユーザーが登録されていません。"
    }

    return(
      <div>
        <HeaderAll />
        <main>

        <div className="main-pannel">
<section>
        会員登録及び月会費決済ページ
        <div className="message">{message}</div>
</section>

          <section>
            <label className="label-def">新規会員登録の方</label>
            <button className="link-btn"  onClick={this.signup}>新規会員登録</button>
          </section>
          <section>
          <label class="label-def">すでに会員登録済みの方</label>
        <FacebookLogin
          appId="217307879141162"
          autoLoad={false}
          fields="name,email,picture"
          onClick={this.componentClicked}
          callback={this.responseFacebook}
          cssClass="fb-button-class"
          textButton="Facebookでログイン"
          icon="fab fa-facebook"
        />
        <LineLogin
          responseLine={this.responseLine}
          client_id={1604258661}
          scope={"profile"}
          redirect_uri={config.get("CALL_BACK_LOGIN")}
          client_secret={"a66a271fdd7dd440a6279d3764916f8b"}
          textButton="LINEでログイン"
          path="login"
        />
        </section>
        <div>
        {inputHtml}
        </div>
        </div>
        </main>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginApp.js